import { render, staticRenderFns } from "./TopSalesTable.vue?vue&type=template&id=366b51d0&scoped=true&"
import script from "./TopSalesTable.vue?vue&type=script&lang=js&"
export * from "./TopSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b51d0",
  null
  
)

export default component.exports